import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  useEffect(() => { document.title = "404 | Aayam Bhattarai"; }, []);

  return (
    <main className="nx-page nx-404">
      <h1>Page not found</h1>
      <p>This page doesn't exist or may have moved. Head back to the home page to keep exploring.</p>
      <button className="nx-btn nx-btn-w" onClick={() => navigate("/")}>Back to home</button>
      <span className="nx-code">Error 404</span>
    </main>
  );
}
